/* eslint-disable */
export default {
  _GameBackground: 'GameBackground',
  _StartBtnFrameLeft: 'StartBtnFrameLeft',
  _LogoBottomLetters: 'LogoBottomLetters',
  _HelpBtn: 'HelpBtn',
  _ResetBtn: 'ResetBtn',
  _LogoTopLetters: 'LogoTopLetters',
  _StartBtn: 'StartBtn',
  _UIBarBottom: 'UIBarBottom',
  _LevelBtn: 'LevelBtn',
  _LevelBtnCleared: 'LevelBtnCleared',
  _particle: 'particle',
  _PuzzleTile: 'PuzzleTile',
  _LevelBtnLocked: 'LevelBtnLocked',
  _PuzzleTileCleared: 'PuzzleTileCleared',
  _HintHighlight: 'HintHighlight',
  _AnswerAreaLeft: 'AnswerAreaLeft',
  _UIBarTrapezoid: 'UIBarTrapezoid',
  _UIBarTop: 'UIBarTop',
  _MenuBtn: 'MenuBtn',
  _MuteBtn: 'MuteBtn',
  _UnmuteBtn: 'UnmuteBtn',
  _CloseBtn: 'CloseBtn',
  _UIBarCenterpiece: 'UIBarCenterpiece',
  _AnswerTileDarkBlue: 'AnswerTileDarkBlue',
  _AnswerTileGreen: 'AnswerTileGreen',
  _AnswerTileLightBlue: 'AnswerTileLightBlue',
  _AnswerTileOrange: 'AnswerTileOrange',
  _AnswerTilePink: 'AnswerTilePink',
  _AnswerTilePurple: 'AnswerTilePurple',
  _AnswerTileRedOrange: 'AnswerTileRedOrange',
  _AnswerTileYellow: 'AnswerTileYellow',
}